export default __webpack_public_path__ + "static/media/left.c94714a0.svg";